import React from 'react'
import { Assessment } from '@LTIDashboard/modules/GeneralDashboard/Assessments/Assessment'

export function Assessments({ assessments }) {
  const inLMS = assessments.filter(item => item.in_canvas === 'true')
  const notInLMS = assessments.filter(item => item.in_canvas === 'false')
  return (
    <React.Fragment>
      <div>
        <h2>Explanation</h2>
        <p>
          This sections contains a summary of the assessments found in our
          database and in canvas. The items are categorized by whether or not
          their GUID (globally unique identifier) can be found in Canvas.
        </p>
        <p>
          GUIDs (globally unique identifier) are used in databases to ensure
          that all records have a unique address across the entire database. In
          our case, every assessments is its own record, meaning it has its own
          GUID. This guarantees that any GUIDs returned by Canvas refer to
          exactly one of our assessments.
        </p>
        <p>
          When opening this page, our system asks Canvas for all assignments
          they have on file for this particular resource. We then parse through
          those results, looking at the <i>external_tool</i> attribute per
          result returned. This attribute includes the unique GUID that matches
          up to one on our assessments.
        </p>
      </div>
      <div>
        <h3 className="text-capitalize">Found in LMS</h3>
        <p>Items here exist in our database and their GUID can be found in the results returned by the Canvas API</p>
      </div>
      {inLMS.map(item => {
        return <Assessment key={item.pk} data={item} />
      })}
      <div>
        <h3 className="text-capitalize">Not in LMS</h3>
        <p>
          Items here exist in our database but their GUID cannot be found in the results by the Canvas API.
        </p>
      </div>
      {notInLMS.map(item => {
        return <Assessment key={item.pk} data={item} />
      })}
    </React.Fragment>
  )
}
